module.exports = __webpack_public_path__ + "static/media/xml.94127870.svg";